// extracted by mini-css-extract-plugin
export default {"accordion":"MyOrderDetail_accordion__WBwHr"};